import { gql } from '@apollo/client';

export default gql`
  query ($searchString: String!) {
    filteredDistricts(searchString: $searchString) {
      districts {
        displayTitle
        id
      }
    }
  }
`;
